<div *ngIf="!isLoading; else loadingComponent">
  <app-form-section-answer
    [group]="group"
    [title]="formData?.title"
    [items]="formItems"
    [readonly]="readonly"
    [formData]="formData"
    [currentStep]="currentStep"
    [isLastGroup]="isLastGroup"
    [isSubmitting]="isSubmitting"
    [initialValues]="initialValues"
    (onPrev)="onPrev.emit()"
    (onCancel)="onCancel.emit()"
    (onSubmit)="onSubmitForm($event)"
  ></app-form-section-answer>
</div>

<ng-template #loadingComponent>
  <div class="card card-fit">
    <div class="card-body pb-1">
      <div
        class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center"
      >
        <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
        <span>Carregando</span>
      </div>
    </div>
  </div>
</ng-template>
